import { render, staticRenderFns } from "./tmall-bill-view.vue?vue&type=template&id=1c543540&scoped=true&"
import script from "./tmall-bill-view.vue?vue&type=script&lang=ts&"
export * from "./tmall-bill-view.vue?vue&type=script&lang=ts&"
import style0 from "./tmall-bill-view.vue?vue&type=style&index=0&id=1c543540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c543540",
  null
  
)

export default component.exports